import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ClientDDL } from "@/views/base/base.types";
import { Icon } from "@/views/sidebar/emoji-key/emoji-key.types";

@Component({
  computed: {
    ...mapState("EmojiKey", [
      "emojiKeys"
    ]),
    ...mapState("Base", [
      "selectedClientDDL"
    ])
  }
})
export default class EmojiMixin extends Vue {
   emojiKeys!: Icon[];
   selectedClientDDL!: ClientDDL;
}